import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router v6 keeps the previous scroll position on navigation. Mount
// this once above the route outlet so every pathname change starts the
// next page at the top. Hash changes (in-page anchors) are intentionally
// excluded so #section deep-links still work.
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
